import Vue from 'vue'
import Router from 'vue-router'
import home from "@/page/activePublic/home"
import Alarm from "@/page/activePublic/Alarm"
import about from "@/page/activePublic/about"
import statusStatistics from "@/page/activePublic/statusStatistics"
import integralcurrquery from "@/page/activePublic/integralcurrquery"
import customizedquery from "@/page/activePublic/customizedquery"
import operstatlist from "@/page/activePublic/operstatlist"
import radiation from "@/page/activePublic/radiation"
import userdefinedquery from "@/page/activePublic/userdefinedquery"
import beamcleaning from "@/page/activePublic/beamcleaning"
import whiteIpList from "@/page/activePublic/userManagement/whiteIpList"
import userManagement from "@/page/activePublic/userManagement/userManagement"
import viewLog from "@/page/activePublic/userManagement/viewLog"
import changeUserInfo from "@/page/activePublic/userManagement/changeUserInfo"
import changePassword from "@/page/activePublic/userManagement/changePassword"

import hadarsStatus from "@/page/activePublic/Metrics/hadarsStatus"
import retrievalMetrics from "@/page/activePublic/Metrics/retrievalMetrics"
import metrics from "@/page/activePublic/Metrics/metrics"
import storage from "@/page/activePublic/Metrics/storage"
import appliances from "@/page/activePublic/Metrics/appliances"

import pvManagement from "@/page/activePublic/pvManagement/pvManagement"
import registerManagement from "@/page/activePublic/userManagement/registerManagement"

import dataSource from "@/page/activePublic/dataSource"

import beamlineOperStatics from "@/page/activePublic/beamlineOperStatics"
import operationStatus from "@/page/activePublic/operationStatus"
Vue.use(Router)

export default new Router({
    mode:"history",
    routes: [
    {
      path:'/',
      name:'Operation Status',
      component:home,
    },
    {
      path:'/home',
      name:'Operation Status',
      component:home,
    },
    {
      path:'/about',
      name:'About',
      component:about
    },
    {
      path:'/analysis/operstatstatistics',
      name:'Operation Status Statistics',
      component:statusStatistics,
    },
    {
      path:'/analysis/integral',
      name:'Integral Current Query',
      component:integralcurrquery,
    },
    {
      path:'/history/customizedquery',
      name:'Historical Data Customized Query',
      component: customizedquery,
    },
    {
      path:'/analysis/operstatlist',
      name:'Operation Status List',
      component:operstatlist,
    },
    {
      path:'/radiation',
      name:'Radiation Monitor',
      component:radiation,
    },
    {
      path:'/history/freequery',
      name:'Historical Data Free Query',
      component:userdefinedquery,
    },{
      path:'/analysis/beamcleaning',
      name:'Beam Cleaning Status',
      component:beamcleaning,
    },{
      path:'/alarm',
      name:'Alarm Infomation',
      component:Alarm,
    },{
      path:'/userManagement/whiteIpList',
      name:'White Ip List',
      component:whiteIpList,
    },{
      path:'/userManagement/userManagement',
      name:'User Management',
      component:userManagement,
    },{
      path:'/userManagement/viewLog',
      name:'View Log',
      component:viewLog,
    },{
      path:'/userManagement/changeUserInfo',
      name:'changeUserInfo',
      component:changeUserInfo,
    },{
      path:'/userManagement/changePassword',
      name:'changePassword',
      component:changePassword,
    },
    {
      path:'/Metrics/hadarsStatus',
      name:'Hadars Status',
      component:hadarsStatus,
    },{
      path:'/Metrics/retrievalMetrics',
      name:'Retrieval Metrics',
      component:retrievalMetrics
    },{
      path:'/Metrics/metrics',
      name:'Metrics',
      component:metrics
    },{
      path:'/Metrics/storage',
      name:'Storage',
      component:storage
    },{
      path:'/Metrics/appliances',
      name:'Appliances',
      component:appliances
    },{
      path:'/pvManagement/pvManagement',
      name:'PV Management',
      component:pvManagement
    },{
      path:'/userManagement/registerManagement',
      name:'Register Management',
      component:registerManagement,
    },{
      path:'/getsource',
      name:'Data Source',
      component:dataSource
    },{
      path:'/analysis/beamlineOperStatics',
      name:'Beamline Oper Statics',
      component:beamlineOperStatics
    },
    ,{
      path:'/operationStatus',
      name:'Operation Status',
      component:operationStatus,
      meta:{showNavBar:false,showFooter:false}//隐藏navbar+footer
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js